<template>
  <div class="home">
<div class="works">
	<div class="works-ban">
		<h2>鑒賞作品</h2>
		<p>首頁 / 鑒賞作品</p>
		<p>
			<span v-for="item in news" :class="{'acts':channel_id==item.id}" @click="buff(item.id)">{{item.title}}</span>
			</p>
	<!-- 	<p><span :class="{'acts':channel_id==3}" @click="buff(3)">遊戲玩家</span><span :class="{'acts':channel_id==4}" @click="buff(4)"> 欣賞 </span><span :class="{'acts':channel_id==1}" @click="buff(1)">作品</span></p> -->
	</div>
	<div class="home-ct">
<div class="wok-con">
	<el-row :gutter="20">
		<el-col :span="10">
			<img class="pic" :src="data.originalPic" />
		</el-col>
		<el-col :span="14">
			<div class="blur">
				<h3>{{data.title}}</h3>
				<div class="aut">
					<span>{{data.author}}</span><span>{{data.dtTime}}</span>
				</div>
				<p>{{data.remark}}</p>
			</div>
		</el-col>
	</el-row>
	<div class="con-buff">
		<div class="tit">
			<div class="ins">
	<div class="but">	<img src="../../assets/qu.png" /></div>	詳細內容</div>
		</div>
		
		<div class="con">
			<div class="pt" v-html="data.content"></div>
		</div>
		
	</div>
 
 </div>

		</div>
</div>
  
    </div>
</template>
<script>




export default {

  data() {
    return {
	id:'',
    data:'',
	news:[],
	channel_id:0
    };
  }, 
 mounted() {
	 
this.id = this.$route.query.id;
this.sandRoom();
		this.sandMate();
		this.sandCase();
		},methods: {
		 scroll(scrollData){
		                console.log(scrollData)
		            },
			        switchCol(col){
			            this.col = col
			            console.log(this.col)
			      },
			      loadmore(index){
			            this.data = this.data.concat(this.data)
			      },

			sandMate(){
			
			this.$axios({
			  method: "post",
			  url: "service.php?action=index_newsDetail",
			  data: {id:this.id},  
			}).then((res) => {
				let data=res.data;
						
				if(data.code==1){
						
					this.data=data.data;
					let content = this.data.content
					const regex = new RegExp('<img', 'gi')
					const reges = new RegExp('type="video/x-ms-asf-plugin" width="550" height="400" autostart="false" loop="true" />', 'gi')
					this.data.content = content.replace(regex, `<img style="max-width: 100%; height: auto;margin-bottom:20px"`)
					this.data.content=this.data.content.replace(/\<embed/gi, '<video width="700" height="470" controls controlslist="nodownload"><source')
					this.data.content=this.data.content.replace(reges, 'type="video/mp4"></video>')
					this.channel_id=data.data.channel_id
					
				}
			 
			});
			
			
			
			},	sandRoom(){
			
			this.$axios({
			  method: "post",
			  url: "service.php?action=index_newsChannel",
			  data: {channel_id:5},  
			}).then((res) => {
				let data=res.data;
						
				if(data.code==1){
			
									
					this.news=data.data;
					
					
				}
			 
			});
			
			
			
			},sandCase(){
				this.$axios({
				  method: "post",
				  url: "/api/noticelist",
				  data: {page:1},  
				}).then((res) => {
					let data=res.data;
					
					if(data.code==200){
						
						this.notice=data.data;
						
						
					
					}
				 
				});
			},buff(item){
this.$router.push({ path: "/works/list?id="+item });	
			}
		}
};
</script>
<style lang="scss" scoped>

.works{
	.wok-con{
		margin-top: 30px;
		.l1{
			line-height: 40px;
		}
		.l2{
			color: #8E8D8D;
		}
	
		.pic{
			width:95%;
		}
		
		.blur{
			h3{
				font-size: 26px;
				text-transform: uppercase
			}
			font-size: 16px;
			.aut{
				line-height: 60px;
				span{
					margin-right: 20px;
				
				}
			}
		}
		
		.con-buff{
			margin-top: 30px;
			.tit{
				font-size: 24px;
				color: #0A0A0A;
				line-height: 50px;
				border-bottom: 1px solid #EAEAEA;
				text-transform: uppercase;
				.ins{
					display:flex;
					margin: 0 auto;
					.but{
						margin-right: 10px;
						padding-top: 5px;
					}
				}
			}
			.con{
				color: #5A5A5A;
				border-bottom: 1px solid #EAEAEA;
				padding: 20px 0;
				.pt{
					width: 700px;
					margin: 0 auto;
					br{
						height: 0;
						margin: 0;
						padding: 0;
					}
				}
			}
		}
		
	}


	.works-ban{
	padding-top: 30px;
	background: #0A0A0A;
	height: 157px;
	color: #FFFFFF;
	text-align: center;
	line-height: 40px;
	h2{
		font-size: 43px;
	}
	p{
		font-size: 18px;
		 cursor: pointer;
	}
	span{
		margin: 20px;
		color: #B5B5B5;
	}
	.acts{
		color: #FFFFFF;
		font-weight: bolder;
	}
	}

}

</style>